import { Form } from 'factorial-form'

class ItemForm extends Form {
  constructor(values: Record<string, string | number | boolean | undefined | null | object>) {
    super(values, {
      id: 'string',
      position: 'number',
      task_type_configuration: 'any',
      task_type: 'string',
      step_id: 'string',
      // Item default fields
      title: 'string',
      instruction: 'string',
      mandatory: 'boolean',
      access_ids: 'any',
      assignee_ids: 'any',
      assignee_type: 'string',
      assignee_identifier: 'string',
      files: 'any',
      // Due date
      offset_direction: 'string',
      offset_amount: 'number',
      reference_field_key: 'string',
      assignee_strategy: 'string',
      location_id: 'string',
      team_ids: 'any',
      team_lead_team_ids: 'any',
      data_collection_configuration: 'any',
      additional_form_data: 'any',
      configuration: 'any',
      configurationIdentifier: 'string',
      configurationId: 'string',
      attachments: 'any',
    })
  }
}

export default ItemForm
